export default {
	listing: []
}